import React, { useState, useEffect } from "react";
import { getToken } from "../api";
const authHeaders = () => ({ "Content-Type": "application/json", ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}) });

const BASE = window.location.hostname === "localhost"
  ? "http://localhost:8001"
  : `${window.location.protocol}//${window.location.host}/api`;

const DAYS = ["Lun","Mar","Mié","Jue","Vie","Sáb","Dom"];
const MONTHS = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
const EVENT_COLORS = ["#8B6914","#3A6B4A","#2E5A8E","#8E2E2E","#6B3A8E","#8E6B2E","#2E8E7A"];

function getDaysInMonth(year, month) { return new Date(year, month + 1, 0).getDate(); }
function getFirstDayOfMonth(year, month) { let d = new Date(year, month, 1).getDay(); return d === 0 ? 6 : d - 1; }

export default function Calendar({ user }) {
  const today = new Date();
  const [year, setYear]     = useState(today.getFullYear());
  const [month, setMonth]   = useState(today.getMonth());
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [modal, setModal]   = useState(null);
  const [toast, setToast]   = useState("");
  const [form, setForm]     = useState({ title: "", time: "", end_time: "", description: "", color: "#8B6914", all_day: false });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 3000); };

  const loadEvents = async () => {
    try { const r = await fetch(`${BASE}/calendar/events`, { headers: authHeaders(), headers: authHeaders() }); const ev = await r.json(); setEvents(Array.isArray(ev) ? ev : []); }
    catch { showToast("Error cargando eventos"); }
  };

  useEffect(() => { loadEvents(); }, []);

  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(y => y - 1); } else setMonth(m => m - 1); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(y => y + 1); } else setMonth(m => m + 1); };
  const dateStr = (d) => `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const eventsForDay = (d) => events.filter(e => e.date === dateStr(d));

  const openCreate = (d) => {
    setSelected(dateStr(d));
    setForm({ title: "", time: "", end_time: "", description: "", color: "#8B6914", all_day: false });
    setModal("create");
  };
  const openEvent = (e, ev) => { ev.stopPropagation(); setModal(e); };

  const saveEvent = async () => {
    if (!form.title.trim()) return showToast("El título es obligatorio");
    try {
      await fetch(`${BASE}/calendar/events`, { headers: authHeaders(),
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, date: selected, created_by: user?.name || "" })
      });
      showToast("Evento creado ✓"); setModal(null); loadEvents();
    } catch { showToast("Error al crear evento"); }
  };

  const deleteEvent = async (id) => {
    try {
      await fetch(`${BASE}/calendar/events/${id}`, { method: "DELETE", headers: authHeaders() });
      showToast("Evento eliminado"); setModal(null); loadEvents();
    } catch { showToast("Error al eliminar"); }
  };

  const daysInMonth = getDaysInMonth(year, month);
  const firstDay    = getFirstDayOfMonth(year, month);
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  const isToday = (d) => d && year === today.getFullYear() && month === today.getMonth() && d === today.getDate();

  const S = {
    wrap: { fontFamily: "Syne, sans-serif", paddingTop: 0 },
    navRow: { display: "flex", alignItems: "center", gap: 16, marginBottom: "1.5rem" },
    navBtn: { background: "none", border: "0.5px solid var(--border)", color: "var(--gold)", cursor: "pointer", fontFamily: "Syne, sans-serif", fontSize: 16, width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "6px" },
    monthLabel: { color: "var(--text)", fontFamily: "Syne, sans-serif", fontSize: 15, letterSpacing: "0.1em", textTransform: "uppercase", minWidth: 200, textAlign: "center", fontWeight: 600 },
    grid: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 1, background: "var(--border)" },
    dayHeader: { background: "var(--bgApp)", padding: "8px 4px", textAlign: "center", fontSize: 9, letterSpacing: "0.15em", textTransform: "uppercase", color: "var(--mute)", fontFamily: "Syne, sans-serif" },
    cell: { background: "var(--card)", minHeight: 80, padding: "6px 8px", cursor: "pointer", position: "relative", transition: "background 0.15s" },
    cellEmpty: { background: "var(--bgApp)", minHeight: 80, opacity: 0.4 },
    cellToday: { background: "var(--lift)", outline: "1px solid var(--goldDim)" },
    dayNum: { fontSize: 11, color: "var(--textSub)", fontFamily: "Syne, sans-serif", marginBottom: 4 },
    dayNumToday: { color: "var(--gold)", fontWeight: 700 },
    eventChip: { fontSize: 10, padding: "2px 6px", marginBottom: 2, cursor: "pointer", borderRadius: "3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#fff", fontWeight: 600 },
    overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
    modalBox: { background: "var(--card)", border: "0.5px solid var(--border)", borderRadius: "8px", padding: "2rem", width: 420, display: "flex", flexDirection: "column", gap: 14 },
    modalTitle: { color: "var(--text)", fontFamily: "Syne, sans-serif", fontSize: 16, fontWeight: 600, margin: 0 },
    label: { fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--mute)", marginBottom: 4, fontFamily: "Syne, sans-serif" },
    input: { background: "var(--lift)", border: "0.5px solid var(--border)", color: "var(--text)", padding: "9px 12px", fontFamily: "Syne, sans-serif", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box", borderRadius: "6px" },
    row: { display: "flex", gap: 8 },
    btn: { padding: "9px 18px", background: "var(--gold)", color: "var(--bgApp)", border: "none", fontFamily: "Syne, sans-serif", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", fontWeight: 700, borderRadius: "5px" },
    btnDanger: { padding: "9px 18px", background: "none", color: "#c0392b", border: "1px solid #c0392b", fontFamily: "Syne, sans-serif", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", borderRadius: "5px" },
    btnCancel: { padding: "9px 18px", background: "none", color: "var(--mute)", border: "0.5px solid var(--border)", fontFamily: "Syne, sans-serif", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", cursor: "pointer", borderRadius: "5px" },
    colorRow: { display: "flex", gap: 8, flexWrap: "wrap" },
    toast: { position: "fixed", bottom: 24, right: 24, background: "var(--card)", border: "1px solid var(--goldDim)", color: "var(--gold)", padding: "10px 20px", fontFamily: "Syne, sans-serif", fontSize: 12, fontWeight: 700, zIndex: 9999, borderRadius: "6px" },
  };

  return (
    <div style={S.wrap}>
      {toast && <div style={S.toast}>{toast}</div>}
      <div style={S.navRow}>
        <button style={S.navBtn} onClick={prevMonth}>‹</button>
        <span style={S.monthLabel}>{MONTHS[month]} {year}</span>
        <button style={S.navBtn} onClick={nextMonth}>›</button>
      </div>
      <div style={S.grid}>
        {DAYS.map(d => <div key={d} style={S.dayHeader}>{d}</div>)}
        {cells.map((d, i) => d === null
          ? <div key={`e${i}`} style={S.cellEmpty} />
          : (
            <div key={d}
              style={{ ...S.cell, ...(isToday(d) ? S.cellToday : {}) }}
              onClick={() => openCreate(d)}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
              <div style={{ ...S.dayNum, ...(isToday(d) ? S.dayNumToday : {}) }}>{d}</div>
              {eventsForDay(d).map(ev => (
                <div key={ev.id} style={{ ...S.eventChip, background: ev.color }}
                  onClick={e => openEvent(ev, e)}>
                  {ev.time && !ev.all_day ? `${ev.time} ` : ""}{ev.title}
                </div>
              ))}
            </div>
          )
        )}
      </div>

      {modal === "create" && (
        <div style={S.overlay} onClick={() => setModal(null)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>
            <h2 style={S.modalTitle}>Nuevo evento — {selected}</h2>
            <div><div style={S.label}>Título *</div>
              <input style={S.input} value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="Reunión, cita, recordatorio..." autoFocus />
            </div>
            <div style={S.row}>
              <div style={{ flex: 1 }}><div style={S.label}>Hora inicio</div>
                <input style={S.input} type="time" value={form.time} onChange={e => setForm(f => ({ ...f, time: e.target.value }))} disabled={form.all_day} />
              </div>
              <div style={{ flex: 1 }}><div style={S.label}>Hora fin</div>
                <input style={S.input} type="time" value={form.end_time} onChange={e => setForm(f => ({ ...f, end_time: e.target.value }))} disabled={form.all_day} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input type="checkbox" id="allday" checked={form.all_day} onChange={e => setForm(f => ({ ...f, all_day: e.target.checked }))} />
              <label htmlFor="allday" style={{ color: "var(--mute)", fontSize: 12, cursor: "pointer", fontFamily: "Syne, sans-serif" }}>Todo el día</label>
            </div>
            <div><div style={S.label}>Descripción</div>
              <textarea style={{ ...S.input, resize: "vertical", minHeight: 60 }} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Opcional..." />
            </div>
            <div><div style={S.label}>Color</div>
              <div style={S.colorRow}>
                {EVENT_COLORS.map(col => (
                  <div key={col} onClick={() => setForm(f => ({ ...f, color: col }))}
                    style={{ width: 24, height: 24, borderRadius: "50%", background: col, cursor: "pointer", outline: form.color === col ? "2px solid var(--text)" : "none", outlineOffset: 2 }} />
                ))}
              </div>
            </div>
            <div style={S.row}>
              <button style={S.btn} onClick={saveEvent}>Guardar</button>
              <button style={S.btnCancel} onClick={() => setModal(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {modal && modal !== "create" && (
        <div style={S.overlay} onClick={() => setModal(null)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: modal.color, flexShrink: 0 }} />
              <h2 style={{ ...S.modalTitle, flex: 1 }}>{modal.title}</h2>
            </div>
            <div style={{ color: "var(--mute)", fontSize: 12, fontFamily: "Syne, sans-serif" }}>
              {modal.date}{modal.all_day ? " · Todo el día" : modal.time ? ` · ${modal.time}${modal.end_time ? ` – ${modal.end_time}` : ""}` : ""}
            </div>
            {modal.description && <div style={{ color: "var(--text)", fontSize: 13, lineHeight: 1.6 }}>{modal.description}</div>}
            <div style={{ color: "var(--mute)", fontSize: 11 }}>Creado por {modal.created_by}</div>
            <div style={S.row}>
              <button style={S.btnDanger} onClick={() => deleteEvent(modal.id)}>Eliminar</button>
              <button style={S.btnCancel} onClick={() => setModal(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
